module.exports = __webpack_public_path__ + "media/images/features/support/heading-comment-966e3820cb57fb1827a9e420c50ec44a.svg";